import { useOrganizationId, useSelectedTenant } from '@/hooks/useSwr';
import HubIcon from '@/icons/HubIcon.svg?react';
import { addQueryParams } from '@/utils/add-query-params';
import { appHubIndexPath } from '@/utils/constants';

import { Breadcrumb, BreadcrumbData } from '../../components/Breadcrumbs';
import { OrganizationCrumb } from '../Organization/OrganizationCrumb';

export function HubCrumb(props: Partial<BreadcrumbData>) {
  const { data: selectedTenant } = useSelectedTenant();
  const organizationId = useOrganizationId();
  const showTenant = !!(selectedTenant && selectedTenant?.tenant_handle);

  return (
    <>
      {showTenant && <OrganizationCrumb {...props} />}
      <Breadcrumb
        name="Hub"
        path={addQueryParams(`/${appHubIndexPath}`, { organizationId })}
        icon={<HubIcon className="relative h-4 w-4" />}
        {...props}
        isFirst={!showTenant}
      />
    </>
  );
}
